<template>
  <v-row justify="center">
    <v-dialog v-model="dialogVisible" persistent max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="closeDialog()">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Email Payment Reminder</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-alert
          v-model="alert.show"
          :dismissible="alert.dismissible"
          :type="alert.type"
          transition="fade-transition"
          class="ma-4"
        >
          {{ alert.text }}
        </v-alert>
        <v-form
          ref="form"
          v-model="form"
          class="px-4 pt-2"
        >

        <p class="mt-4" v-if="selectedStallholder"><strong>Stallholder: </strong>{{selectedStallholder.stall_name}}</p>
        <p class="mb-6" v-if="selectedStallholder"><strong>Email:</strong> {{selectedStallholder.email}}</p>

        <v-checkbox v-for="(booking, i) in unpaidBookingsSorted"
          :key="i"
          class="my-0"
          color="primary"
          v-model="formData.id" :label="bookingCheckboxLabel(booking)" :value="booking.id"
          >
        </v-checkbox>

        <div class="text-center" v-if="isLoading">
          <p class="primary--text">Loading unpaid bookings...</p>
          <v-progress-circular
            indeterminate
            align="center"
            color="primary"
          ></v-progress-circular>
        </div>

        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="primary darken-1"
              text
              @click.stop="submitForm()"
              :disabled="isSaveBtnDisabled"
              :loading="isSaveBtnLoading"
          >
              Send Email
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="isSaveBtnLoading" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>
<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import { formatDate } from '../js/helpers'

export default {
  data: () => ({
    dialog: '',
    formData : {
       id: []
    },
    unpaidBookings : [],
    isSaveBtnLoading: false,
    isCloseBtnDisabled: false,
    isLoading: true,
    alert: {
      show: false,
      text: '',
      type: 'success',
      dismissible: true,
    },
    form: false,
    alert: {
      show: false,
      text: '',
      type: 'info',
      dismissible: true,
    }
  }),
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectedId : {
      required: true,
    },
  },
  watch: {
    dialogVisible(newData, oldData) {
        if(newData) { console.log("NEW DATTA");
          this.getUnpaidBookings();
          this.formData = { id: [] }; //selected booking ids
        }
    },
  },
  methods: {
    closeDialog(){
      this.$emit('close');
      this.unpaidBookings = [];
      this.formdata = {};
      this.isSaveBtnLoading = false;
      this.resetAlert();
    },
    submitForm(){

      this.resetAlert();
       
      this.sendEmailReminder();

    },
    bookingCheckboxLabel(booking){
        let stall = this.getStallById(booking.stall_id);
        return formatDate(booking.market_date) + ": " + stall.stall_title;
    },
    sendEmailReminder(){
      this.savingDialog = true;
      this.isSaveBtnLoading = true;

      axios({
        method: 'POST',
        url: `/wisdom-markets/v1/send-payment-reminder`,
        headers: {
            'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        data: this.formData
      })
      .then(response => {
        console.log("saved", response);
        this.isSaveBtnLoading = false;
        this.savingDialog = false;
        this.showAlert('success', 'Email sent!');

        //assume succesfully sent emails and remove selected ones from list
        // this.formData.id.forEach(bookingId => {
        //   let index = this.unpaidBookings.findIndex(item => item.id === bookingId);

        //   if (index !== -1) {

        //      // mark as paid for current week selected, no need to do all, because the booking data is re fetched whenever the date changes
        //     if(this.unpaidBookings[index].market_date == this.$store.state.selectedMarketDate) {
        //       this.unpaidBookings[index].last_emailed_date = true; // normally a date is stored in database, this is only for visual purposes to hide the "unnotified icon" (if visible)
        //       this.$emit('update', this.unpaidBookings[index]);
        //     }

        //     // then remove from unpaid list
        //     this.unpaidBookings.splice(index, 1); 
        //   }
        // })

        response.data.bookings_updated.forEach(booking => {
          
          let unpaidIndex = this.unpaidBookings.findIndex(item => item.id === booking.id);

          if (unpaidIndex !== -1) {

             // update bookings for current week selected, no need to do all because the booking data is re fetched whenever the date changes
            if(booking.market_date == this.$store.state.selectedMarketDate) {
              this.$emit('update', booking); // update with new repsonse from server, ie the 'last emailed' would have been updated, and hence the "unnotified icon" will be hidden (if was visible)
            }

            // then remove from unpaid list
            this.unpaidBookings.splice(unpaidIndex, 1); 
          }
        })

        this.formData.id = []; //reset selected booking ids

      })
      .catch(error => {
        console.log("error sending email", error);
        this.isSaveBtnLoading = false;
        this.savingDialog = false;
        let message = 'Error!';

        if(error.response.data && error.response.data.message)
          message = message+' '+error.response.data.message;

        this.showAlert('error', message);
      });

    },
    showAlert(type, text){
      this.alert.show = true;
      this.alert.text = text
      this.alert.type = type;
    },
    resetAlert() { //and reset
      this.alert = {
        show: false,
        text: '',
        type: 'info',
        dismissible: true,
      }
    },
    getUnpaidBookings(){
       this.isLoading = true;

       const today = new Date();
       const todayDate = today.getFullYear() + '-' + ('00' + (today.getMonth()+1)).slice(-2) + '-' +('00' + today.getDate()).slice(-2)

       axios.get(`/wisdom-markets/v1/bookings/?stallholder_id=${this.selectedId}&is_paid=0&deleted_date&is_cancelled=0&market_date_from=${todayDate}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        },
      })
      .then( (response) => {
        console.log('got unpaid books', response.data);

        this.unpaidBookings = response.data;
        this.isLoading = false;
      })
      .catch((error) => {
        console.log(error);
        console.log("why the!!!!!");
        this.isLoading = false;
      })
    },
  },
  computed: {
    isDialogVisible(){
        if(this.dialog != this.dialogVisible) {
            return this.dialogVisible
        }else{
            return this.dialog
        }
    },
    ...mapGetters([
      'getStallById',
      'getStallholderColor',
      'getStallholderById'
    ]),
    selectedStallholder() {
      return this.getStallholderById(this.selectedId)
    },
    unpaidBookingsSorted(){
      return this.unpaidBookings.sort( (a, b) => {
          return a.market_date === b.market_date ? 0 : a.market_date > b.market_date ? 1 : -1;
      })
    },
    isSaveBtnDisabled(){
      return this.formData.id.length > 0 ? false : true;
    }
  },
  mounted() {
    //
  },

}
</script>